import React, { CSSProperties } from 'react'
import { ErrorOutline } from '@mui/icons-material'
import { Tooltip, TooltipProps, Typography } from '@mui/material'
import { styled } from '@mui/material/styles';
import { tooltipClasses } from '@mui/material/Tooltip';
import { atticusColors } from 'theme';


const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    width: "50rem",
    backgroundColor: atticusColors.fileBackgroundBlue,
    maxWidth: "50rem",
    padding: "1rem",
  },
}));

export function KeepInMindInfoIcon(props: { style?: CSSProperties, tooltipProps?: TooltipProps }): JSX.Element {
  const toolTip = <div style={{ color: "black" }}>
    <Typography component="div" style={{ width: "100%", textAlign: "center", marginBottom: "1rem" }}><b>Keep in mind</b></Typography>
    <Typography component="div" variant="body2">
      The link you’ve uploaded will be displayed using an embedded viewer. However, please keep in mind:
    </Typography>
    <ul>
      <li style={{ marginBottom: "0.5rem" }}>
        <Typography component="div" variant="body2">
          If the link requires a sign-in or is behind a security wall, Atticus may not be able to access or display the content.
        </Typography>
      </li>
      <li>
        <Typography component="div" variant="body2">
          Visibility and editing permissions are controlled by the original platform (e.g., Google Docs, Dropbox, OneDrive). Other users in Atticus may not be able to view or edit the file unless they have the appropriate access on the source platform.
        </Typography>
      </li>
    </ul>
    <Typography component="div" variant="body2">
      If you experience difficulty, please check the file’s sharing settings on its original platform. If the issue persists, consider downloading the file and uploading it directly to your Atticus File Cabinet for a more seamless experience.
    </Typography>
  </div>

  return <HtmlTooltip
    disableFocusListener // Allows hover or touch to trigger tooltip
    arrow={true}
    title={toolTip}
    style={{ width: "50rem", cursor: "help" }}
    placement="bottom-start"
    slotProps={{
      arrow: {
        style: { color: atticusColors.fileBackgroundBlue },
      },
      popper: {
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, -8],
            },
          },
        ],
      },
    }}
    {...props.tooltipProps}
  >
    <ErrorOutline style={props.style} />
  </HtmlTooltip>
}